import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useDropzone } from 'react-dropzone';

const getTransition = (theme) => {
    if (!theme?.transitions?.create) {
        return 'background-color 250ms cubic-bezier(0.0, 0, 0.2, 1)';
    }

    return theme.transitions.create('background-color', {
        duration: theme?.transitions?.duration?.shorter || 250,
        easing: theme?.transitions?.easing?.easeOut || 'cubic-bezier(0.0, 0, 0.2, 1)',
    });
};

const StyledContainer = styled('div')(({ theme }) => ({
    'backgroundColor': theme?.palette?.action?.hover || 'rgba(0, 0, 0, 0.04)',
    'cursor': 'pointer',
    'padding': '1rem',
    'textAlign': 'center',
    'color': '#999',
    'borderRadius': theme?.shape?.borderRadius || 4,
    'transition': getTransition(theme),
    '&:hover': {
        backgroundColor: theme?.palette?.action?.disabledBackground || 'rgba(0, 0, 0, 0.12)',
    },
}));

const StyledDropzoneMessage = styled(Typography)({
    fontSize: '16px',
});

const AttachmentDropzone = (props) => {
    const {
        accept = {
            'image/*': ['.jpg', '.jpeg', '.png'],
            'application/*': ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'],
            'text/csv': ['.csv'],
        },
        multiple = true,
        title = 'Drop a file to upload, or click to browse.',
        onFileSelected,
    } = props;

    const {
        getRootProps,
        getInputProps,
    } = useDropzone({
        onDrop: onFileSelected,
        accept,
        multiple,
    });

    return (
        <StyledContainer {...getRootProps({ id: 'file-input-dropzone' })}>
            <input {...getInputProps()} />
            <StyledDropzoneMessage variation="body1" align="center" color="textSecondary">
                { title }
            </StyledDropzoneMessage>
        </StyledContainer>
    );
};

AttachmentDropzone.propTypes = {
    accept: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    multiple: PropTypes.bool,
    title: PropTypes.string,
    onFileSelected: PropTypes.func.isRequired,
};

export default AttachmentDropzone;
